import type { SpecifyUserPermission } from "../../api/types";

export const canBrowseTeamSessions = (permission: SpecifyUserPermission, userId: string) =>
  permission === "All" ||
  permission === "AllCompany" ||
  (typeof permission === "object" && permission.SpecificUsers.some(id => id !== userId));
